import axios from 'axios'

export const getMyOnboardingSteps = () => {
  return axios.get('/office-activity/my-onboarding-steps')
}

export const submitOnboardingActivity = ({ officeActivityListId }) => {
  return axios.post(`/office-activity/submit/${officeActivityListId}`)
}
